import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '@app/gateway/services/api.service';
import { StorageService } from "@app/services/storage/storage.service";
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { AppealsService } from '../appeals.service';
import Vs from '@app/services/validators/validators.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'nh-appeal-petition-submission',
    templateUrl: './appeal-petition-submission.component.html',
    styleUrls: ['./appeal-petition-submission.component.scss'],
    standalone: false
})
export class AppealPetitionSubmissionComponent implements OnInit {
    translatedLang;
    memberInfo={appealNumber:'',indvId:'',caseNumber:''};    
    selectedItem;
    errorMessage:boolean=false;

    appealPetitionSubmissionForm = new FormGroup({
        appealPetitionResponse: new FormControl('', [Vs.required, Vs.aplPetitionResponse]),
        relationshipWithAppellant: new FormControl('', [Vs.required, Vs.aplRelationship]),
        phoneNumber: new FormControl('', [Vs.required, Vs.phoneNumber]),              
        submittedBy: new FormControl('', [Vs.required, Vs.aplSubmittedBy])
    });

    get form() { return this.appealPetitionSubmissionForm['controls']; }


    constructor(public translateService: TranslateService, public app: ApiService,protected storageService: StorageService, private router: Router, public appealsService: AppealsService,public activatedRoute: ActivatedRoute,private titleService: Title) { 
      this.titleService.setTitle('Appeal Fact Submission');
    }

    ngOnInit() {      
        const defaultLanguage = this.translateService.getDefaultLang();
        this.translatedLang = defaultLanguage;        
        this.translateService.onDefaultLangChange.subscribe((res) => {
            this.translatedLang = res.lang            
        });
        this.appealsService.showMessageAppealPetition=false;
    }

    onValueChange(formControlName): void {
        this.selectedItem = this.appealPetitionSubmissionForm.controls[formControlName].value.code;
    };
    
    goToAppealsDashboard(){
        this.router.navigateByUrl("user-profile/my-appeals");
    }

    isFormValid(): boolean {
        return ((this.appealPetitionSubmissionForm.status === "VALID"));
    }

    onSubmit(controls, currentLanguage): void {       
      this.memberInfo.appealNumber= sessionStorage.getItem('af_appealNum'); 
      this.memberInfo.indvId=sessionStorage.getItem('af_indvid');
      this.memberInfo.caseNumber=sessionStorage.getItem('af_caseNumber');
      this.appealsService.saveAppealPetitonForm(this.memberInfo, controls, currentLanguage);
    };    

   

    ngAfterContentInit() {
        this.appealPetitionSubmissionForm.controls["submittedBy"].valueChanges.pipe().subscribe(() => {          
         // this.submittedValidator(this.appealFactSubmissionForm.controls);
      });
    }

}
 